type ErrorResponseData =
  | string
  | {
      error?: string | { message?: string };
      publicMessage?: string;
      message?: string;
      ERROR?: string;
    };

// COMS sends a JSON string body (not a JSON response) from the legacy
// `logInformationSendResponse` path, so axios leaves it unparsed.
function parseJsonBody(data: string) {
  try {
    const parsed = JSON.parse(data);
    return typeof parsed === 'object' && parsed !== null ? parsed : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Extract a human-readable message from an API error.
 *
 * Handles every response shape COMS produces: the `AppError` envelope (`{
 * error: { code, message } }`), legacy `{ error: 'message' }` and `{ message }`
 * bodies, and unparsed JSON string bodies.
 */
export function parseError(error: unknown): string | undefined {
  const axiosError = error as { response?: { data?: ErrorResponseData } };
  const rawData = axiosError?.response?.data;
  const data = typeof rawData === 'string' ? parseJsonBody(rawData) : rawData;

  if (data) {
    if (typeof data.error === 'string' && data.error) {
      return data.error;
    }
    if (typeof data.error === 'object' && data.error?.message) {
      return data.error.message;
    }
    if (typeof data.publicMessage === 'string' && data.publicMessage) {
      return data.publicMessage;
    }
    if (typeof data.message === 'string' && data.message) {
      return data.message;
    }
    if (typeof data.ERROR === 'string' && data.ERROR) {
      // The legacy path sends a bare sentinel rather than a sentence.
      return data.ERROR === 'UNAUTHORIZED'
        ? 'You are not authorized to perform this action.'
        : data.ERROR;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }
}
